// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon_icon__ZG9ss","width-auto":"Icon_width-auto__xmuv_"};